import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../theme';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minHeight: '20rem',
            alignItems: 'center',
            borderBottom: `1px solid ${brandColors.tableBorder}`,
            borderLeft: `1px solid ${brandColors.tableBorder}`,
            borderRight: `1px solid ${brandColors.tableBorder}`,
            [theme.breakpoints.down('sm')]: {
                borderTop: `1px solid ${brandColors.tableBorder}`,
                marginTop: theme.spacing(1),
            },
        },
        icon: {
            marginBottom: theme.spacing(2),
            padding: theme.spacing(2),
            backgroundColor: brandColors.main,
            borderRadius: '50%',
            display: 'flex',
            color: theme.palette.primary.contrastText,
        },
    };
};
